import {
  usePackageTrackPageConfigContext,
  PackageTrackPageConfigContextProvider
} from "./PackageTrackPageConfigContext";

export default usePackageTrackPageConfigContext;
export { PackageTrackPageConfigContextProvider };
